import { BambooArt } from "./BambooArt";
import type { ArtView, BambooStyle } from "../types";

interface NameBambooArtProps {
  name: string;
  view: ArtView;
  style: BambooStyle;
}

export function NameBambooArt({ name, view, style }: NameBambooArtProps) {
  const characters = Array.from(name).slice(0, 4);
  return (
    <div
      className={`name-bamboo-art name-bamboo-art--${characters.length} name-bamboo-art--view-${view}`}
      role="img"
      aria-label={`竹叶藏名：${name}`}
    >
      {characters.map((character, index) => (
        <BambooArt
          key={`${character}-${index}`}
          character={character}
          phrase={name}
          view={view}
          style={style}
          labelled={false}
        />
      ))}
      {view === "meaning" && <p>{name}<span>一叶藏一名</span></p>}
    </div>
  );
}
